export const getElapsedSeconds = (startedAt: number): number =>
  Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
